import axios, { AxiosResponse } from "axios";
import React, { FC, useContext, useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import { IField } from "../Interfaces/AdminInterface";
import AuthContext from "../../contexts/AuthContext";

import { toast } from "react-toastify";
import { getRequest } from "../../services/axiosService";

interface IProps {
    currentValue: IField | undefined, 
    endpoint: string,
    placeHolder: string, 
    callback: any,
    name: string
}

// similar to CMSearch except it shows all dropdown items
const CMDropdownOptions: FC<IProps> = ({endpoint, currentValue, placeHolder, callback, name}) => {

    const { auth } = useContext(AuthContext);

    const [options, setOptions] = useState<IField[]>([])
    const [currentText, setCurrentText] = useState<string>("");
    const [value, setValue] = useState<string>("");
    const [placeHolderTxt, setPlaceHolder] = useState<string>(placeHolder);
    const [initLoad, setInitLoad] = useState<boolean>(false);
    const [currentEndpoint, setCurrentEndpoint] = useState<string>(endpoint);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        async function getData() {
            if (!initLoad || currentEndpoint !== endpoint) {
                await getOptions();
                setCurrentEndpoint(endpoint);
                setInitLoad(true);
            }
            if (currentValue) {
                setValue(currentValue.value);
                setCurrentText(currentValue.name);
                setPlaceHolder(currentValue.name);
            }
            setLoading(false);
        }
        getData();
    }, [currentValue, value, endpoint]);

    const getOptions = async () => {

        setLoading(true);
        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/${endpoint}`);

            let count = 0;
            let userFields = response.data.map((field: IField) => {
                return {
                    text: field.name,
                    value: field.value,
                    key: field.name.replaceAll(" ", "_")
                }
            });
            setOptions(userFields);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve options`);
        }
    }

    const onChange = (e: any, data: any) => {
        if (data.value === "") {
            callback(null);
            setCurrentText("");
            return;
        }

        let selectedItem = data.options.find((x: any) => x.value === data.value);
        let obj = {
            name: selectedItem.text,
            value: selectedItem.value,
            text: selectedItem.text,
        };

        callback(obj);
        setCurrentText(selectedItem.text);
    }

    return (
        <Dropdown
            style={{ backgroundColor: "#e5e5e5", marginBottom: 10 }}
            name={name} 
            className="bgGrey" 
            placeholder={currentText === "" ? placeHolder : currentText}
            value={value}
            fluid
            search
            clearable={true}
            loading={ loading}
            selection
            text={currentText === "" ? placeHolder : currentText}
            options={options}
            onChange={onChange}
        />
    );
}

export default CMDropdownOptions;

